module.exports = __webpack_public_path__ + "static/img/peixun1.9a48fbdd.png";